/* eslint-disable no-console -- this module IS the dev-only console wrapper: its single log call is gated on isDevelopment and never emits in production (#8698 gate). */
import { isDevelopment } from '@/lib/config';

/**
 * Development-only `console.log`.
 *
 * For diagnostics that help while building but are noise — or a leak — in a
 * user's production console: expected-404 responses, lifecycle traces, request
 * config dumps (which carry Authorization headers). A real fault still uses
 * `console.error` unconditionally; this helper is deliberately not a general
 * logging abstraction.
 *
 * Guarded on `isDevelopment` (NODE_ENV === 'development'), so production
 * bundles keep the call but it never emits. Safe on the server too — it only
 * touches `console`.
 */
export function devLog(...args: unknown[]): void {
  if (!isDevelopment) return;
  console.log(...args);
}
